<template>
  <main class="recharge-page" role="main">    
    <vue-loading :active.sync="is_loading" 
        :can-cancel="false"         
        :is-full-page="false"></vue-loading>    
    <recharge-details v-if="!is_loading"></recharge-details>    
  </main>
</template>

<script>
import store from "@/store";
import RechargeDetails from "./recharge-details.vue";

export default {
  name: "fixed-lte-recharge",
  components: {        
    "recharge-details": RechargeDetails
  },
  data() {
    return {
      is_loading: false,
    };
  },
  computed: {    
    isLoading() {
      return store.state.products.is_loading;
    }
  },  
  watch: {
    isLoading(value){
      var self = this;
      self.is_loading = value;
    }
  },
  mounted() {
    var self = this;          
    self.$scrollTo("body");  
  },
  methods: {    
  }
};
</script>